import { IPricingPlan } from '../types';

export const pricingPlans: IPricingPlan[] = [
  {
    id: 'Free',
    name: '무료',
    price: {
      monthly: 0,
      yearly: 0
    },
    period: '채널당/월',
    description: '가볍게 시작해보는',
    features: [
      { text: '최초 100 AI 크레딧', included: false, isGradient: true },
      { text: '콘텐츠 3개 제작 ', included: true },
      { text: '기본 콘텐츠 템플릿', included: true },
      { text: '기본 상호작용, 실감기술 도구', included: true },
      { text: '콘텐츠 플레이 수 데이터', included: true }
    ],
    cta: {
      text: '자세히 보기',
      variant: 'secondary'
    }
  },
  {
    id: 'Pro',
    name: '프로',
    badge: '추천 요금제',
    price: {
      monthly: 14900,
      yearly: 149000
    },
    period: '채널당/월',
    description: '전문 크리에이터를 위한',
    discount: {
      yearly: 16
    },
    features: [
      { text: '무료의 모든 기능 +', included: true, highlight: true },
      { text: '월 500 AI 크레딧', included: false, isGradient: true },
      { text: '콘텐츠 10개 제작', included: true },
      { text: '고급 템플릿', included: true },
      { text: '모든 상호작용, 실감기술 도구', included: true },
      { text: '미션별 완료율 데이터', included: true },
      { text: '후원받기 기능', included: true },
      { text: '테스터 3명 초대', included: true }
    ],
    cta: {
      text: '구독하기',
      variant: 'primary'
    },
    highlighted: true
  },
  {
    id: 'Enterprise',
    name: '엔터프라이즈',
    price: {
      monthly: null,
      yearly: null
    },
    period: '',
    description: '광고, 앱 설치 NO! 행사 운영 효율을 높인',
    features: [
      { text: '프로의 모든 기능 +', included: true, highlight: true },
      { text: '월 10,000 AI 크레딧', included: false, isGradient: true },
      { text: '콘텐츠 무제한 제작', included: true },
      { text: '플레이 시간 데이터', included: true },
      { text: '앱 설치 없이 모바일 웹플레이 가능', included: true },
      { text: '콘텐츠 시작, 하단 광고 제거', included: true },
      { text: '채널 소유자, 편집자, 테스터 초대', included: true }
    ],
    cta: {
      text: '맞춤 견적 받기',
      variant: 'primary'
    }
  },
  {
    id: 'Class',
    name: '클래스',
    price: {
      monthly: null,
      yearly: null
    },
    period: '',
    description: '창의 학습, 수업에 적용하기 좋은',
    features: [
      { text: '교육 특화 기능 추가', included: true, highlight: true },
      { text: '월 10,000 AI 크레딧', included: false, isGradient: true },
      { text: '콘텐츠 무제한 제작', included: true },
      { text: '교육 맞춤형 템플릿 추가 제공', included: true },
      { text: 'LMS 활용 가능 데이터', included: true },
      { text: '앱 설치 없이 모바일 웹플레이 가능', included: true },
      { text: '콘텐츠 시작, 하단 광고 제거', included: true },
      { text: '채널 소유자, 편집자, 테스터 초대', included: true }
    ],
    cta: {
      text: '더 알아보기',
      variant: 'primary'
    }
  }
];
